import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';
import './contingencia.css';

// TODO: Reemplazar los placeholders [INSERTAR_...] con los datos reales antes del deploy.
const PHASES = [
    {
        title: 'Detección y Contención',
        time: '0–15 minutos',
        items: [
            'El sistema de monitoreo 24/7 detecta el fallo y emite alerta automática.',
            'El equipo técnico evalúa la naturaleza y severidad del incidente.',
            'Se contiene el incidente para minimizar el impacto en los contribuyentes.',
            'Se notifica al responsable de contacto con la DGII si aplica.',
        ],
    },
    {
        title: 'Activación del Plan',
        time: '15–60 minutos',
        items: [
            'Activación del entorno de respaldo (failover automático o manual).',
            'Verificación de integridad de los últimos backups disponibles.',
            'Inicio del proceso de restauración si fuera necesario.',
            'Comunicación a los contribuyentes afectados por los canales habilitados.',
        ],
    },
    {
        title: 'Restauración del Servicio',
        time: 'Hasta RTO = 4 horas',
        items: [
            'Verificación funcional completa del entorno de respaldo.',
            'Confirmación de que los e-CF en cola sean procesados.',
            'Comunicación de restablecimiento del servicio.',
            'Documentación del incidente.',
        ],
    },
    {
        title: 'Análisis Post-Incidente',
        time: 'Posterior a la recuperación',
        items: [
            'Análisis de causa raíz del evento.',
            'Restauración del entorno principal y sincronización de datos.',
            'Reporte final documentado.',
        ],
    },
];

const PoliticaContingencia = () => {
    return (
        <LegalPageLayout
            seoTitle="Política de Contingencia y Continuidad Operativa"
            path="/politica-de-contingencia"
            description="Procedimientos de contingencia y continuidad operativa del servicio de facturación electrónica de Coralan Multiservice SRL."
            breadcrumbLabel="Política de Contingencia"
            title="Política de Contingencia y Continuidad Operativa"
            subtitle="Procedimientos y medidas que garantizan la continuidad de los servicios de Facturación Electrónica de Coralan Multiservice SRL ante incidentes, desastres o interrupciones del servicio."
        >
            <div className="legal-page__content">
                <div className="contingencia-version">
                    <i className="fas fa-calendar-check" aria-hidden="true"></i>
                    <span>Vigente desde: <strong>Mayo 2026</strong></span>
                    <span className="contingencia-version__sep">|</span>
                    <span>Versión <strong>1.0</strong></span>
                </div>

                {/* 1. Objetivo */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">1.</span>
                        Objetivo
                    </h2>
                    <p>
                        Establecer los procedimientos y medidas necesarias para garantizar
                        la continuidad operativa de los servicios de Coralan Multiservice
                        SRL ante incidentes, desastres o interrupciones, asegurando que
                        los contribuyentes puedan continuar emitiendo Comprobantes Fiscales
                        Electrónicos (e-CF) en cumplimiento con los requisitos de la DGII.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 2. Alcance */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">2.</span>
                        Alcance
                    </h2>
                    <p>Esta política aplica a:</p>
                    <ul>
                        <li>
                            Todos los servicios críticos de emisión, firma y transmisión de e-CF.
                        </li>
                        <li>La infraestructura tecnológica que soporta la plataforma.</li>
                        <li>Las bases de datos de comprobantes y certificados digitales.</li>
                        <li>Las comunicaciones con los contribuyentes durante incidentes.</li>
                        <li>La conectividad con los sistemas de la DGII.</li>
                    </ul>
                </div>

                <hr className="contingencia-hr" />

                {/* 3. Objetivos de recuperación */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">3.</span>
                        Objetivos de Recuperación
                    </h2>
                    <div className="contingencia-table-wrap">
                        <table className="contingencia-table">
                            <thead>
                                <tr>
                                    <th>Métrica</th>
                                    <th>Objetivo</th>
                                    <th>Descripción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Tiempo de restauración (RTO)</td>
                                    <td className="contingencia-table__metric">4 horas</td>
                                    <td>Tiempo máximo para restablecer el servicio completo.</td>
                                </tr>
                                <tr>
                                    <td>Pérdida máxima de datos (RPO)</td>
                                    <td className="contingencia-table__metric">1 hora</td>
                                    <td>Máximo período de datos que podría perderse.</td>
                                </tr>
                                <tr>
                                    <td>Disponibilidad mensual</td>
                                    <td className="contingencia-table__metric">99.5%</td>
                                    <td>≈ 3.6 horas de interrupción permitida por mes.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="contingencia-table__note">
                        <strong>Nota:</strong> el objetivo de disponibilidad del 99.5% está
                        calculado de forma conservadora para absorber posibles interrupciones
                        en servicios de infraestructura y eventuales mantenimientos de los
                        sistemas de la DGII, que están fuera del control de Coralan Multiservice SRL.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 4. Continuidad ante indisponibilidad DGII — Callout */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">4.</span>
                        Continuidad ante Indisponibilidad de la DGII
                    </h2>
                    <div className="contingencia-callout">
                        <div className="contingencia-callout__icon" aria-hidden="true">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <span className="contingencia-callout__label">Garantía fundamental</span>
                        <h3 className="contingencia-callout__title">
                            Ningún documento se pierde, incluso si la DGII está fuera de servicio.
                        </h3>
                        <p>
                            Cuando los servicios de la DGII no están disponibles,
                            Coralan Multiservice continúa operando. Los documentos se
                            almacenan en cola de forma persistente y se procesan
                            automáticamente cuando la DGII restablece el servicio.
                        </p>
                        <p>
                            Coralan Multiservice detecta automáticamente la indisponibilidad
                            de la DGII y encola los documentos de forma segura hasta que el
                            servicio se restablezca. El procesamiento se reanuda
                            automáticamente sin intervención del contribuyente.
                        </p>
                    </div>
                </div>

                <hr className="contingencia-hr" />

                {/* 5. Clasificación de incidentes */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">5.</span>
                        Clasificación de Incidentes
                    </h2>
                    <div className="contingencia-table-wrap">
                        <table className="contingencia-table">
                            <thead>
                                <tr>
                                    <th>Nivel</th>
                                    <th>Prioridad</th>
                                    <th>Descripción</th>
                                    <th>Tiempo de respuesta</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <span className="contingencia-badge contingencia-badge--p1">P1</span>
                                    </td>
                                    <td>Crítica</td>
                                    <td>Servicio completamente inoperativo. Sin emisión de e-CF.</td>
                                    <td className="contingencia-table__metric">30 min (24/7)</td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="contingencia-badge contingencia-badge--p2">P2</span>
                                    </td>
                                    <td>Alta</td>
                                    <td>Fallo parcial del servicio. Impacto significativo.</td>
                                    <td className="contingencia-table__metric">2 horas</td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="contingencia-badge contingencia-badge--p3">P3</span>
                                    </td>
                                    <td>Media</td>
                                    <td>Funcionalidad degradada. Existe alternativa temporal.</td>
                                    <td className="contingencia-table__metric">4 horas hábiles</td>
                                </tr>
                                <tr>
                                    <td>
                                        <span className="contingencia-badge contingencia-badge--p4">P4</span>
                                    </td>
                                    <td>Baja</td>
                                    <td>Consultas, errores menores sin impacto operativo.</td>
                                    <td className="contingencia-table__metric">8 horas hábiles</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p style={{ marginTop: 14 }}>
                        Coralan Multiservice prioriza la respuesta según el impacto en las
                        operaciones de facturación electrónica, atendiendo primero los
                        incidentes que afectan la emisión de e-CF.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 6. Procedimientos de respuesta */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">6.</span>
                        Procedimientos de Respuesta
                    </h2>
                    <div className="contingencia-phases">
                        {PHASES.map((phase, idx) => (
                            <div className="contingencia-phase" key={phase.title}>
                                <div className="contingencia-phase__num">{idx + 1}</div>
                                <h3 className="contingencia-phase__title">
                                    Fase {idx + 1} — {phase.title}
                                </h3>
                                <span className="contingencia-phase__time">{phase.time}</span>
                                <ul>
                                    {phase.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <hr className="contingencia-hr" />

                {/* 7. Estrategia de respaldo */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">7.</span>
                        Estrategia de Respaldo
                    </h2>
                    <p>
                        Aplicamos la estrategia <strong>3-2-1</strong>, estándar de la
                        industria para protección de datos críticos:
                    </p>
                    <div className="contingencia-321">
                        <div className="contingencia-321__card">
                            <div className="contingencia-321__num">3</div>
                            <p className="contingencia-321__label">Copias de los datos</p>
                        </div>
                        <div className="contingencia-321__card">
                            <div className="contingencia-321__num">2</div>
                            <p className="contingencia-321__label">
                                Tipos de medios de almacenamiento
                            </p>
                        </div>
                        <div className="contingencia-321__card">
                            <div className="contingencia-321__num">1</div>
                            <p className="contingencia-321__label">
                                Copia almacenada fuera del sitio (offsite / nube)
                            </p>
                        </div>
                    </div>

                    <div className="contingencia-table-wrap">
                        <table className="contingencia-table">
                            <thead>
                                <tr>
                                    <th>Tipo de respaldo</th>
                                    <th>Frecuencia</th>
                                    <th>Retención</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Base de datos de e-CF (incremental)</td>
                                    <td>Cada hora</td>
                                    <td className="contingencia-table__metric">5 años</td>
                                </tr>
                                <tr>
                                    <td>Datos de contribuyentes</td>
                                    <td>Diario</td>
                                    <td className="contingencia-table__metric">5 años</td>
                                </tr>
                                <tr>
                                    <td>Certificados digitales (cifrados)</td>
                                    <td>Ante cada cambio</td>
                                    <td className="contingencia-table__metric">Vigencia + 5 años</td>
                                </tr>
                                <tr>
                                    <td>Configuraciones del sistema</td>
                                    <td>Diario</td>
                                    <td className="contingencia-table__metric">1 año</td>
                                </tr>
                                <tr>
                                    <td>Logs y bitácoras (streaming)</td>
                                    <td>Tiempo real</td>
                                    <td className="contingencia-table__metric">5 años</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p style={{ marginTop: 14 }}>
                        Todos los respaldos son verificados semanalmente mediante pruebas
                        de restauración parcial. Mensualmente se realiza una prueba de
                        restauración completa.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 8. Infraestructura redundante */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">8.</span>
                        Infraestructura Redundante
                    </h2>
                    <ul>
                        <li>
                            Servidores en múltiples zonas de disponibilidad con failover
                            automático.
                        </li>
                        <li>Doble enlace de Internet con proveedores ISP independientes.</li>
                        <li>
                            UPS y generador eléctrico de respaldo en las instalaciones
                            principales.
                        </li>
                        <li>Sitio alterno de procesamiento para escenarios de desastre mayor.</li>
                        <li>
                            Replicación de base de datos en tiempo real entre entornos
                            primario y de respaldo.
                        </li>
                    </ul>
                </div>

                <hr className="contingencia-hr" />

                {/* 9. Comunicación durante incidentes */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">9.</span>
                        Comunicación durante Incidentes
                    </h2>
                    <p>
                        Durante incidentes significativos, Coralan Multiservice notificará
                        a los clientes afectados por los siguientes medios:
                    </p>
                    <ul>
                        <li>
                            <strong>Correo electrónico:</strong> notificación inmediata a los
                            contribuyentes afectados.
                        </li>
                        <li>
                            <strong>Portal web:</strong> publicación de aviso en{' '}
                            <strong>coralanmultiservice.com</strong>.
                        </li>
                        <li>
                            <strong>WhatsApp / Teléfono:</strong> para incidentes P1 y P2.
                        </li>
                        <li>
                            <strong>DGII:</strong> notificación al contacto designado dentro
                            de las 24 horas del incidente.
                        </li>
                    </ul>
                    <p>
                        Los mantenimientos programados se comunicarán con al menos{' '}
                        <strong>48 horas de anticipación</strong>. Los mantenimientos
                        ordinarios se realizan preferiblemente en horarios de baja demanda
                        (domingos de 2:00 AM a 6:00 AM) y no superarán 4 horas continuas.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 10. Pruebas y validación */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">10.</span>
                        Pruebas y Validación
                    </h2>
                    <ul>
                        <li><strong>Prueba de restauración de respaldos:</strong> mensual.</li>
                        <li><strong>Simulacro de failover de servidor:</strong> semestral.</li>
                        <li>
                            <strong>Simulacro completo de recuperación ante desastres:</strong>{' '}
                            anual.
                        </li>
                        <li>
                            <strong>Revisión y actualización de este documento:</strong> anual
                            o ante cambios significativos.
                        </li>
                    </ul>
                    <p>
                        Los resultados de cada prueba se documentan y utilizan para mejorar
                        el plan.
                    </p>
                </div>

                <hr className="contingencia-hr" />

                {/* 11. Contacto de emergencia */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">11.</span>
                        Contacto de Emergencia
                    </h2>
                    <div className="contingencia-contact">
                        <div className="contingencia-contact__row">
                            <span className="contingencia-contact__label">
                                <i className="fas fa-envelope" aria-hidden="true"></i> Correo de soporte
                            </span>
                            <span className="contingencia-contact__value">
                                {/* TODO: confirmar correo final */}
                                info@coralanmultiservice.com
                            </span>
                        </div>
                        <div className="contingencia-contact__row">
                            <span className="contingencia-contact__label">
                                <i className="fas fa-phone-alt" aria-hidden="true"></i> Teléfono de emergencias (24/7)
                            </span>
                            <span className="contingencia-contact__value">
                                +1 (809) 605-0699
                            </span>
                        </div>
                        <div className="contingencia-contact__row">
                            <span className="contingencia-contact__label">
                                <i className="fas fa-globe" aria-hidden="true"></i> Portal de soporte
                            </span>
                            <span className="contingencia-contact__value">
                                <Link to="/soporte">coralanmultiservice.com/soporte</Link>
                            </span>
                        </div>
                    </div>
                </div>

                <hr className="contingencia-hr" />

                {/* 12. Marco legal */}
                <div className="legal-page__section">
                    <h2 className="legal-page__section-title">
                        <span className="legal-page__section-num">12.</span>
                        Marco Legal
                    </h2>
                    <ul>
                        <li>
                            <strong>Ley No. 11-92:</strong> Código Tributario (conservación
                            de datos fiscales).
                        </li>
                        <li>
                            <strong>Ley No. 126-02:</strong> Comercio Electrónico, Documentos
                            y Firmas Digitales.
                        </li>
                        <li>
                            <strong>Normativas DGII:</strong> Sobre Facturación Electrónica
                            (e-CF).
                        </li>
                        <li>
                            <strong>Ley No. 172-13:</strong> Protección de Datos Personales.
                        </li>
                        <li>
                            <strong>Ley No. 32-23:</strong> Sobre Ciberseguridad.
                        </li>
                    </ul>
                </div>

                {/* CTA final */}
                <div className="legal-page__cta">
                    <div className="legal-page__cta-text">
                        <p className="legal-page__cta-title">
                            ¿Tienes una incidencia activa o consulta sobre continuidad?
                        </p>
                        <p className="legal-page__cta-subtitle">
                            Nuestro equipo de soporte está disponible para asistirte.
                        </p>
                    </div>
                    <Link to="/soporte" className="legal-page__cta-btn">
                        Ir a Soporte <i className="fas fa-arrow-right"></i>
                    </Link>
                </div>
            </div>
        </LegalPageLayout>
    );
};

export default PoliticaContingencia;
